import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";

export class ArbetsorderAtgardProduktionAvslutadGrotValidation {
    static init(viewModel: { currentStatus: string }): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.spara, ValidationErrorLevels.warning).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "Åtgärden utförd måste anges" },
                model: () => viewModel.currentStatus,
                expression: (newValue) => ObjectUtils.stringHasValue(newValue),
                name: "currentStatus",
                required: true
            }
        ]);
        return context;
    }
}
